import { inject, Injectable } from '@angular/core';
import { PasNotification, PasNotificationService, PasNotificationType } from '@porsche-aftersales/frontend-toolbox';

@Injectable({
  providedIn: 'root',
})
export class NotificationServiceWrapper {
  private readonly pasNotificationService = inject(PasNotificationService);

  public addSuccessNotification(title: string, content: string): void {
    this.pasNotificationService.addNotification(new PasNotification(title, content, PasNotificationType.SUCCESS, 5000));
  }

  public addErrorNotification(title: string, content: string): void {
    this.pasNotificationService.addNotification(new PasNotification(title, content, PasNotificationType.ERROR, -1));
  }

  public addWarningNotification(title: string, content: string): void {
    this.pasNotificationService.addNotification(new PasNotification(title, content, PasNotificationType.WARN, -1));
  }
}
